import type { InsightCategory } from "./api";

/**
 * The nine insight categories (INS-1, INS-6), each with the word the interface shows and the
 * colour its badge wears. One place, so a category reads the same on a review card, the
 * recording detail's Insights tab and (later) the insights ledger.
 *
 * The list is closed: a `Reasoner` that wanted a tenth category was a prompt failure to
 * fix, never a new category, so this map is exhaustive by construction.
 */
export interface InsightCategoryMeta {
  category: InsightCategory;
  label: string;
  /** A CSS colour token reference for the badge tint. */
  colour: string;
}

export const INSIGHT_CATEGORIES: InsightCategoryMeta[] = [
  { category: "decision", label: "Decision", colour: "var(--vl-life)" },
  { category: "commitment", label: "Commitment", colour: "var(--vl-bridge)" },
  { category: "deadline", label: "Deadline", colour: "var(--vl-accent-warm)" },
  { category: "fact", label: "Fact", colour: "var(--vl-virtual)" },
  { category: "preference", label: "Preference", colour: "var(--vl-life-soft)" },
  { category: "request", label: "Request", colour: "var(--vl-bridge-soft)" },
  { category: "requirement", label: "Requirement", colour: "var(--warning)" },
  { category: "update", label: "Update", colour: "var(--text-secondary)" },
  { category: "question", label: "Question", colour: "var(--vl-virtual-soft)" },
  { category: "product_improvement", label: "Product improvement", colour: "var(--destructive)" },
];

const BY_CATEGORY = new Map(INSIGHT_CATEGORIES.map((meta) => [meta.category, meta]));

export function categoryMeta(category: InsightCategory): InsightCategoryMeta {
  return BY_CATEGORY.get(category) ?? INSIGHT_CATEGORIES[3]!;
}

export function categoryLabel(category: InsightCategory): string {
  return categoryMeta(category).label;
}
